/*
 *  Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import styled from "styled-components";
import { Button, FlexContainer, theme } from "@nordcloud/gnui";
import { SearchPresetV2 } from "~/generated/graphql";
import { List } from "~/components";

type Props = {
  items: SearchPresetV2[];
  onDelete: (deleteItem: { id: string; name: string }) => void;
  onClick: (preset: SearchPresetV2) => void;
};

export function SearchPresetList({ items, onDelete, onClick }: Props) {
  const handleDelete = (
    event: React.MouseEvent,
    { id, name }: SearchPresetV2
  ) => {
    event.stopPropagation();
    onDelete({ id, name });
  };

  return (
    <List selectable>
      {items.map((item) => (
        <ListItem key={item.id} onClick={() => onClick(item)}>
          <FlexContainer justifyContent="space-between">
            <span css={{ maxWidth: "90%", wordBreak: "break-word" }}>
              {item.name}
            </span>
            <Button
              icon="trash"
              severity="low"
              size="md"
              onClick={(event: React.MouseEvent) => handleDelete(event, item)}
            />
          </FlexContainer>
        </ListItem>
      ))}
    </List>
  );
}

const ListItem = styled.li({
  padding: theme.spacing.spacing02,
  borderTop: `1px solid ${theme.color.border.border01}`,

  "&:first-of-type": {
    borderTop: "none",
  },
});
